import type { ServerResponseV1 } from "@/http"
import type { PredefinedSortOrder } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

export async function updateAlbumSort(eventVaultId: number, sort: PredefinedSortOrder): Promise<void> {
  await v1.patch<ServerResponseV1<void>>(`/events/${eventVaultId}/albums/sort-order?orderType=${sort.toString()}`)
}

export function useUpdateAlbumSort() {
  return useMutation({
    mutationFn: ({ eventVaultId, sort }: { eventVaultId: number, sort: PredefinedSortOrder }) => updateAlbumSort(eventVaultId, sort),
  })
}
